import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { AuthService } from '../modules/auth/auth.service';
import { LoaderService } from './loader.service';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { ModalService } from './modal.service';
import { Helper } from '../helper';
import firebase from 'firebase/compat/app';

@Injectable({
  providedIn: 'root',
})
export class FirebaseMessagingService {
  serviceWorkerUrl: string = '/firebase-messaging-sw.js';

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private httpService: HttpService,
    private authService: AuthService,
    private loaderService: LoaderService,
    private modalService: ModalService
  ) {}

  requestPermission() {
    navigator.serviceWorker.register(this.serviceWorkerUrl).then((registration) => {
      setTimeout(() => {
        this.getToken(registration);
      });
    });
  }

  private getToken(registration: ServiceWorkerRegistration) {
    const messaging = firebase.messaging();
    messaging
      .getToken({
        serviceWorkerRegistration: registration,
      })
      .then((token) => {
        this.sendDeviceToken(token);
      });
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe({
      next: (payload: firebase.messaging.MessagePayload) => {
        const payloadNotification = payload.notification;

        Notification.bind(new Notification(payloadNotification.title, { body: payloadNotification.body }));
      },
    });
  }

  sendDeviceToken(token: string) {
    this.loaderService.showLoader();

    this.authService.sendFirebaseMessagingDeviceToken(token).subscribe({
      next: () => {
        this.loaderService.hideLoader();
      },
      error: (error) => {
        const errorDetails = Helper.getErrorDetails(error);
        this.modalService.openAlertModal(errorDetails['message'], errorDetails['detail']);
        this.loaderService.hideLoader();
      },
    });
  }
}
